var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:home-solid",
    clipPath: "url(#clip0_416_2584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9333 0.160044C10.8126 0.0567576 10.6589 0 10.5 0C10.3411 0 10.1874 0.0567576 10.0667 0.160044L0.5 8.36004V18C0.5 18.5305 0.710714 19.0392 1.08579 19.4143C1.46086 19.7893 1.96957 20 2.5 20H7.83333C8.01014 20 8.17971 19.9298 8.30474 19.8048C8.42976 19.6798 8.5 19.5102 8.5 19.3334V15.3334C8.5 14.8029 8.71071 14.2942 9.08579 13.9192C9.46086 13.5441 9.96957 13.3334 10.5 13.3334C11.0304 13.3334 11.5391 13.5441 11.9142 13.9192C12.2893 14.2942 12.5 14.8029 12.5 15.3334V19.3334C12.5 19.5102 12.5702 19.6798 12.6953 19.8048C12.8203 19.9298 12.9899 20 13.1667 20H18.5C19.0304 20 19.5391 19.7893 19.9142 19.4143C20.2893 19.0392 20.5 18.5305 20.5 18V8.36004L10.9333 0.160044Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_2584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b5eeb999ddd8209bf07461baa9ed17ae.svg";
export { ForwardRef as ReactComponent };